import { TableCell, TableRow } from '@client/toolkit';

interface ReportTableSkeletonRowsProps {
  columns: number;
  rows?: number;
}

/** Loading placeholder rows for the portfolio report registers. */
export function ReportTableSkeletonRows({ columns, rows = 5 }: ReportTableSkeletonRowsProps) {
  return (
    <>
      {Array.from(Array(rows).keys()).map((x) => (
        <TableRow key={x}>
          {Array.from(Array(columns).keys()).map((y) => (
            <TableCell key={y} loading />
          ))}
        </TableRow>
      ))}
    </>
  );
}
